import { ReactComponent as NextArrowIcon } from '@Icons/additional/arrow-left.svg';
import { ReactComponent as DownloadIcon } from '@Icons/additional/download.svg';
import { ReactComponent as SearchIcon } from '@Icons/additional/search.svg';

import styles from './confirmation-mobile.module.css';
import ActionButtons from './component/ActionButtons/ActionButtons';

interface ConfirmationMobileLayoutProps {
  backToText?: string;
  caption?: string;
  actions?: JSX.Element | null;
  content?: JSX.Element | null;
  hidePagination?: boolean;
  handleBack: () => void;
  handleCancel: () => void;
  handleConfirm: () => void;
}

const ConfirmationMobileLayout: React.FC<ConfirmationMobileLayoutProps> = ({
  handleBack,
  handleCancel,
  handleConfirm,
  caption = 'Material Confirmation',
  actions,
  content,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <NextArrowIcon onClick={handleBack} />
        <div>{caption}</div>
        <div className={styles.actions}>
          <DownloadIcon className={styles.icon} />
          <SearchIcon className={styles.icon} />
        </div>
      </div>
      <div className={styles.navigationTabs}>
        <div className={styles.actionGroup}>{actions}</div>
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.actionButtons}>
        <ActionButtons
          handleBack={handleCancel}
          handleConfirm={handleConfirm}
        />
      </div>
    </div>
  );
};

export default ConfirmationMobileLayout;
